import { DisplayableMenu } from "../../../../../store/api/upsellApi";
import { Box, ButtonBase, Card } from "@mui/material";
import { grey } from "@mui/material/colors";
import { MenuBook } from "@mui/icons-material";
import React, { ReactElement } from "react";
import AddIcon from "@mui/icons-material/Add";

export function Menus({
  menus,
  reorderable = false,
  allowAdd = false,
  onAdd,
  children,
}: {
  menus: DisplayableMenu[];
  reorderable?: boolean;
  allowAdd?: boolean;
  onAdd: () => void;
  children: (menu: DisplayableMenu, index: number) => ReactElement;
}) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
      {menus.map((menu, index) => children(menu, index))}
      {allowAdd ? (
        <ButtonBase onClick={onAdd} title={"Add a menu"}>
          <Card
            elevation={0}
            sx={{
              border: `1px dotted ${grey[800]}`,
              width: "100%",
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // bit convoluted.
              //   (font-size title * line-height)
              // + (font-size id    * line-height)
              // + vertical padding on gridArea menu
              // + vertical padding on grid itself
              height: "calc(1em * 1.5 + 0.9em * 1.5 + 4px + 16px)",
            }}
          >
            <AddIcon sx={{ color: "gray", display: "inline" }} />{" "}
            <MenuBook color={"primary"} sx={{ display: "inline" }} />
          </Card>
        </ButtonBase>
      ) : null}
    </Box>
  );
}
